/**
 * Convert a Fahrenheit temperature to the user's preferred unit.
 * Returns a rounded integer.
 */
export function convertTemp(tempF: number, unit: 'FAHRENHEIT' | 'CELSIUS'): number {
  if (unit === 'CELSIUS') {
    return Math.round((tempF - 32) * 5 / 9);
  }
  return Math.round(tempF);
}

/**
 * Return the display label for the temperature unit.
 */
export function tempUnitLabel(unit: 'FAHRENHEIT' | 'CELSIUS'): string {
  return unit === 'CELSIUS' ? '°C' : '°F';
}
